import React from "react";
import { Card, Group } from "@mantine/core";
import { format } from "date-fns";
import Title from "../../../../components/Elements/Title/Title";

interface LinkedInUpdateProps {
  item: {
    id: number;
    category: { id: number; name: string };
    title: string;
    created: string;
    linkUrl: string;
  };
}

const LinkedInUpdateCard: React.FC<LinkedInUpdateProps> = ({ item }) => (
  <Card
    padding="md"
    radius="md"
    withBorder
    className="!rounded-2xl !bg-[#131316] !border-[#2f2f31] gap-4"
  >
    <Group justify="space-between">
      <Title title={item.category.name} className="!mb-0"></Title>
      <div className="text-right text-[#9e9e9f] text-sm font-medium uppercase">
        {format(new Date(item.created), "HH:mm, dd.MM.yyyy.")}
      </div>
    </Group>
    {item.title && (
      <div className="text-neutral-50 text-base font-bold">{item.title}</div>
    )}
    {item.linkUrl && (
      <div>
        <a
          href={item.linkUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sky-500 text-sm font-medium underline"
        >
          {item.linkUrl}
        </a>
      </div>
    )}
  </Card>
);

export default LinkedInUpdateCard;
